import { usePreviewStore } from '@/stores/preview';
import { shouldFallbackToStable } from '@/stores/preview/helper';
import { useProjectStore } from '@/stores/project';
import { createPreviewStartupTracker } from './previewStartupTracking';
function getContext() {
    var _previewState_pendingPreviewNavigation;
    const previewState = usePreviewStore.getState();
    const projectState = useProjectStore.getState();
    const pluginStatus = previewState.previewDebugInfo.live.pluginLoadStatus;
    const stableReady = Boolean(previewState.preReleaseUrl) && previewState.preReleaseReady && previewState.preReleaseIframeReady;
    const shouldFallbackStable = shouldFallbackToStable(previewState.livePreviewProblem);
    let displayedIframeType = 'none';
    if (previewState.livePreviewStatus === 'ready' && previewState.sandboxIframeReady) {
        displayedIframeType = 'live';
    } else if (previewState.livePreviewStatus === 'error') {
        displayedIframeType = shouldFallbackStable ? stableReady ? 'stable' : 'none' : previewState.sandboxUrl ? 'live' : stableReady ? 'stable' : 'none';
    } else if (previewState.targetLayer === 'stable' && stableReady) {
        displayedIframeType = 'stable';
    }
    return {
        preview_route: ((_previewState_pendingPreviewNavigation = previewState.pendingPreviewNavigation) === null || _previewState_pendingPreviewNavigation === void 0 ? void 0 : _previewState_pendingPreviewNavigation.targetLayer) === 'live' ? previewState.pendingPreviewNavigation.targetRoute : previewState.currentIframeRoute,
        target_layer: previewState.targetLayer,
        active_preview_source: previewState.activePreviewSource,
        displayed_iframe_type: displayedIframeType,
        preview_problem: previewState.livePreviewProblem ?? 'none',
        live_preview_status: previewState.livePreviewStatus,
        sandbox_status: projectState.sandboxStatus,
        runtime_connection_status: previewState.sandboxRuntimeConnectionStatus,
        bridge_status: previewState.previewDebugInfo.live.bridgeStatus,
        content_ready: previewState.sandboxContentReady,
        iframe_ready: previewState.sandboxIframeReady,
        has_sandbox_url: Boolean(previewState.sandboxUrl),
        has_stable_url: Boolean(previewState.preReleaseUrl),
        plugin_load_status: (pluginStatus === null || pluginStatus === void 0 ? void 0 : pluginStatus.status) ?? 'unreported'
    };
}
export const previewStartupTracker = createPreviewStartupTracker({
    collectEvent: (eventName, payload)=>{
        if (typeof collect !== 'undefined') {
            collect(eventName, payload);
        }
    },
    getContext
});
